import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SidenavComponent } from './sidenav.component';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { RouterModule } from '@angular/router';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatSelectModule } from '@angular/material/select';
import { MatListModule } from '@angular/material/list';
import { CountsComponent } from './components/counts/counts.component';
import { CountsModule } from '../counts/counts.module';
import { EstimatorCalendarSelectComponent } from './components/estimator-calendar-select/estimator-calendar-select.component';
import { CalendarFiltersComponent } from './components/calendar-filters/calendar-filters.component';
import { ProductionCalendarFiltersComponent } from './components/production-calendar-filters/production-calendar-filters.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { ServiceCalendarFiltersComponent } from './components/service-calendar-filters/service-calendar-filters.component';
import { LogoutDialogComponent } from './components/logout-dialog/logout-dialog.component';

@NgModule({
  declarations: [
    SidenavComponent,
    CountsComponent,
    EstimatorCalendarSelectComponent,
    CalendarFiltersComponent,
    ProductionCalendarFiltersComponent,
    ServiceCalendarFiltersComponent,
    LogoutDialogComponent,
  ],
  imports: [
    CommonModule,
    MatButtonModule,
    MatIconModule,
    MatFormFieldModule,
    MatInputModule,
    RouterModule,
    MatExpansionModule,
    MatSelectModule,
    MatListModule,
    CountsModule,
    SharedModule,
  ],
  exports: [SidenavComponent],
})
export class SidenavModule {}
